import { inEnum } from "@ciaopeople/cp-shatsu/TypeChecking";
import { CPProductName, isCPProductName } from "./CPProducts.js";

export enum YMCiaopeopleSite {

    FANPAGE = "fanpage",
    COOKISTIT = "ck_it",
    COOKISTWOW = "ck_wow",
    COOKISTLEGAL = "ck_legal",
    OHGA = "ohga",
    KODAMI = "kodami",
    GEOPOP = "geopop",
    WAMILY = "wamily",
    LEXPLAIN = "lexplain"

}



const mapped: {[k in CPProductName]: YMCiaopeopleSite} = {
    
    FANPAGE: YMCiaopeopleSite.FANPAGE,
    COOKIST: YMCiaopeopleSite.COOKISTIT,
    COOKIST_WOW: YMCiaopeopleSite.COOKISTWOW,
    OHGA: YMCiaopeopleSite.OHGA,
    KODAMI: YMCiaopeopleSite.KODAMI,
    GEOPOP: YMCiaopeopleSite.GEOPOP,
    WAMILY: YMCiaopeopleSite.WAMILY,
    LEXPLAIN: YMCiaopeopleSite.LEXPLAIN

}

const reversemap: {[k in YMCiaopeopleSite]?: CPProductName} = Object.entries(mapped).reduce((acc,entry) => {
    const [k,v] = entry;
    acc[v] = k;
    return acc;
},{})




export function getYMCiaopeopleSiteByProduct(product: CPProductName): YMCiaopeopleSite {
    return mapped[product];
}

export function getProductByYMCiaopeopleSite(site: YMCiaopeopleSite): CPProductName {
    return reversemap[site];
}


export function linearizeToYMCiaopeopleSite(site: CPProductName | YMCiaopeopleSite): YMCiaopeopleSite {
    if(isCPProductName(site)) {
        return getYMCiaopeopleSiteByProduct(site);
    }
    else if(inEnum(site,YMCiaopeopleSite)) {
        return site;
    }
    else return null;
}